/**
 * The wordmark is typeset, not drawn: Fraunces with WONK on, tight tracking, and
 * the ampersand set slightly smaller and optically raised so "Chapters&Co" reads
 * as one word rather than three parts.
 *
 * The name is always rendered as exactly "Chapters&Co" — no spaces around the
 * ampersand, no "& Co.", no lowercase.
 */
export default function Wordmark({ className = '', as: Tag = 'span' }) {
  return (
    <Tag
      className={`font-display leading-none tracking-tight whitespace-nowrap ${className}`}
      style={{ fontVariationSettings: "'SOFT' 20, 'WONK' 1, 'opsz' 96", fontWeight: 600 }}
    >
      Chapters
      <span
        aria-hidden="true"
        className="inline-block align-baseline"
        style={{ fontSize: '0.82em', paddingInline: '0.02em' }}
      >
        &amp;
      </span>
      Co
    </Tag>
  );
}
